// @flow
import React, { type Node, useMemo, useCallback } from 'react';
import find from 'ramda/es/find';
import propEq from 'ramda/es/propEq';

import PlainItemPicker from 'app/common/ui-next/plain-item-picker';
import type { Klasses, Klass } from 'app/dataTypes/Klasses.types';

import KlassSwitcherItem from './KlassSwitcherItem';
import styles from './KlassSwitcher.scss';


type Props = {
  klasses: Klasses,
  klassId: string,
  onChangeKlass: (string) => void,
}

const KlassSwitcher = ({ klasses, klassId, onChangeKlass }: Props): Node => {
  const currenKlassTitle = useMemo(() => {
    const currentItem: Klass | void = find(propEq('id', klassId), klasses);
    return currentItem ? currentItem.title : '';
  }, [klassId, klasses]);

  const handleKlassClick = useCallback(({ id }: { +id: string }) => {
    if (id) {
      onChangeKlass(id);
    }
  }, [onChangeKlass]);

  return (
    <div className={styles.root}>
      <div className={styles.klass}>
        {currenKlassTitle}
      </div>

      <PlainItemPicker onItemClick={handleKlassClick}>
        {klasses.map(({ id, title, schoolyearTitle }) => (
          <KlassSwitcherItem
            key={id}
            id={id}
            title={title}
            schoolyearTitle={schoolyearTitle}
            current={id === klassId}
          />
        ))}
      </PlainItemPicker>
    </div>
  );
};

export default KlassSwitcher;
